function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
/* Shared, versioned discovery rules. No wallet, DOM, storage or network work. */
(function (root, factory) {
  var api = factory();
  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) module.exports = api;else root.SnakeStickers = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Discovery recipe version, independent of the catalog and NFT metadata versions.
  // v1 stays readable for outstanding tickets and persisted browser evidence.
  var VERSION = 2;
  var DAILY_VERSION = 3;
  var supportedVersion = function supportedVersion(value) {
    return value === 1 || value === 2 || value === DAILY_VERSION;
  };
  var dailyBinding = function dailyBinding(v) {
    return v.version !== DAILY_VERSION || /^\d{4}-\d{2}-\d{2}$/.test(v.day) && /^[a-f0-9]{32}$/.test(v.competition);
  };
  var MAX_PAIRS = 200;
  var REACTIONS = Object.freeze(['six-seven', 'squashed', 'bonk', 'absolute-unit', 'vacuum', 'meltdown', 'rodeo', 'mad-scientist', 'chaos-chef', 'alien-abduction', 'too-much-aura', 'toilet-portal', 'rocket-launch', 'dj-drop', 'wizard', 'popcorn-panic', 'brain-freeze', 'gamer-rage', 'tornado', 'detective', 'royal-tantrum', 'bubblegum-blowout', 'pirate-panic', 'caffeine-overload', 'skate-wipeout', 'flash-frenzy', 'deep-sea-derp', 'noodle-nightmare', 'spring-surprise', 'ninja-nonsense', 'bubble-bath', 'sneeze-blast']);
  var TIERS = Object.freeze(['normal', 'shiny', 'super-shiny']);
  var HEX = /^[a-f0-9]{64}$/;
  var KEY = /^[1-9A-HJ-NP-Za-km-z]{43,45}$/;
  var uint = function uint(n) {
    return Number.isInteger(n) && n >= 0 && n <= 0xffffffff;
  };
  function rng(seed) {
    var state = seed >>> 0;
    return function () {
      state = state + 0x6D2B79F5 >>> 0;
      var n = Math.imul(state ^ state >>> 15, 1 | state);
      n ^= n + Math.imul(n ^ n >>> 7, 61 | n);
      return ((n ^ n >>> 14) >>> 0) / 4294967296;
    };
  }
  function tier(roll) {
    var version = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : VERSION;
    if (!Number.isFinite(roll) || roll < 0 || roll >= 1) throw new Error('Invalid rarity roll');
    if (!supportedVersion(version)) throw new Error('Unknown discovery version');
    var normal = version === 1 ? 0.89 : 0.978,
      shiny = version === 1 ? 0.99 : 0.998;
    return roll < normal ? 'normal' : roll < shiny ? 'shiny' : 'super-shiny';
  }
  function variant(id) {
    if (typeof id !== 'string') return null;
    var _id$split = id.split(':'),
      _id$split2 = _slicedToArray(_id$split, 3),
      reaction = _id$split2[0],
      rarity = _id$split2[1],
      extra = _id$split2[2];
    if (extra !== undefined || !REACTIONS.includes(reaction) || !TIERS.includes(rarity)) return null;
    return Object.freeze({
      id: id,
      reaction: reaction,
      tier: rarity,
      title: reaction === 'six-seven' ? 'Six Seven' : reaction.split('-').map(function (s) {
        return s[0].toUpperCase() + s.slice(1);
      }).join(' '),
      tierLabel: rarity === 'super-shiny' ? 'Super shiny' : rarity === 'shiny' ? 'Shiny' : 'Normal',
      baseImage: reaction === 'six-seven' ? 'six-seven-emoji.webp' : "six-seven-reaction-".concat(reaction, ".webp")
    });
  }
  var CATALOG = Object.freeze(REACTIONS.flatMap(function (id) {
    return TIERS.map(function (t) {
      return variant("".concat(id, ":").concat(t));
    });
  }));
  function backingNolans(id) {
    var quantity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var item = variant(id);
    if (!item || !Number.isInteger(quantity) || quantity < 1 || quantity > MAX_PAIRS) throw new Error('Invalid sticker backing request');
    var saito = item.tier === 'normal' ? 1n : item.tier === 'shiny' ? 10n : 20n;
    return saito * 100000000n * BigInt(quantity);
  }
  function sequence(artSeed, raritySeed) {
    var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : MAX_PAIRS;
    var version = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : VERSION;
    if (!supportedVersion(version)) throw new Error('Unknown discovery version');
    if (!uint(artSeed) || !uint(raritySeed) || !Number.isInteger(count) || count < 0 || count > MAX_PAIRS) {
      throw new Error('Invalid discovery recipe');
    }
    var draw = rng(artSeed),
      rarity = rng(raritySeed),
      result = [];
    var bag = [],
      previous = null;
    while (result.length < count) {
      if (!bag.length) {
        bag = _toConsumableArray(REACTIONS);
        for (var i = bag.length - 1; i > 0; i--) {
          var j = Math.floor(draw() * (i + 1));
          var _ref = [bag[j], bag[i]];
          bag[i] = _ref[0];
          bag[j] = _ref[1];
        }
        if (bag[0] === previous) {
          var _ref2 = [bag[1], bag[0]];
          bag[0] = _ref2[0];
          bag[1] = _ref2[1];
        }
      }
      previous = bag.shift();
      result.push("".concat(previous, ":").concat(tier(rarity(), version)));
    }
    return result;
  }
  function normalizeTicket(value) {
    var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
    if (!value || !supportedVersion(value.version) || !dailyBinding(value) || !HEX.test(value.id) || !HEX.test(value.token) || !uint(value.runSeed) || !uint(value.artSeed) || !uint(value.raritySeed) || !Number.isSafeInteger(value.expiresAt) || value.expiresAt <= now) return null;
    return _objectSpread({
      version: value.version,
      id: value.id,
      token: value.token,
      runSeed: value.runSeed,
      artSeed: value.artSeed,
      raritySeed: value.raritySeed,
      expiresAt: value.expiresAt
    }, value.version === DAILY_VERSION ? {
      day: value.day,
      competition: value.competition
    } : {});
  }
  function claimMessage(value) {
    if (!value || !supportedVersion(value.version) || !dailyBinding(value) || !HEX.test(value.ticketId) || !HEX.test(value.token) || !KEY.test(value.owner) || !value.run || !uint(value.run.seed) || !Number.isInteger(value.run.steps) || value.run.steps < 1 || value.run.steps > 100000 || typeof value.run.turns !== 'string' || value.run.turns.length > 50000) return null;
    // The secret ticket is sent only over same-origin HTTPS, never on chain or in a public replay.
    return JSON.stringify(_objectSpread(_objectSpread({
      purpose: 'snake-sticker-claim',
      version: value.version,
      ticketId: value.ticketId,
      token: value.token,
      owner: value.owner
    }, value.version === DAILY_VERSION ? {
      day: value.day,
      competition: value.competition
    } : {}), {}, {
      run: {
        seed: value.run.seed,
        steps: value.run.steps,
        turns: value.run.turns
      }
    }));
  }
  function counts(discoveries) {
    var result = {};
    var _iterator = _createForOfIteratorHelper(discoveries),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var id = _step.value;
        if (!variant(id)) throw new Error('Unknown sticker');
        result[id] = (result[id] || 0) + 1;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return result;
  }
  return Object.freeze({
    VERSION: VERSION,
    DAILY_VERSION: DAILY_VERSION,
    MAX_PAIRS: MAX_PAIRS,
    REACTIONS: REACTIONS,
    TIERS: TIERS,
    CATALOG: CATALOG,
    HEX: HEX,
    KEY: KEY,
    rng: rng,
    tier: tier,
    variant: variant,
    backingNolans: backingNolans,
    sequence: sequence,
    normalizeTicket: normalizeTicket,
    claimMessage: claimMessage,
    counts: counts
  });
});